function appendGoogleMapScript(mapId, onLoadCallback, mapSelector) {
    const scriptMap = $('#google-map-script'),
        mapIds = [];

    $('[data-map-id]').each(function () {
        mapIds.push($(this).data('map-id'));
    })

    if (!scriptMap.length) {
        const defaultCoords = $('meta[name="default-coords"]').attr('content').split(',');
        const key = $('meta[name=google-api-key]').attr('content');
        const script = document.createElement('script');

        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + key + '&v=beta&callback=initMapLocation&map_ids=' + mapIds.join(',');
        script.id = 'google-map-script';
        script.async = true;

        window.initMapLocation = function() {
            const clusterScript = document.createElement('script');
            clusterScript.src = '/assets/public/js/mapclusterer.js';
            document.head.append(clusterScript);

            const infwoverlayScript = document.createElement('script');
            infwoverlayScript.src = '/assets/public/js/infwoverlay.js';
            infwoverlayScript.async = true;

            infwoverlayScript.onload = () => {
                const map = new google.maps.Map(document.getElementById(mapSelector), {
                    zoom: 15,
                    center: {lat: parseFloat(defaultCoords[0]), lng: parseFloat(defaultCoords[1])},
                    mapTypeControl: false,
                    scaleControl: false,
                    fullscreenControl: false,
                    streetViewControl: false,
                    mapId: mapId
                });

                if (onLoadCallback !== undefined) {
                    onLoadCallback(map);
                }
            }

            document.head.append(infwoverlayScript);
        };

        document.head.appendChild(script);
    }
}

$(function () {

    var mapBlockId = 'infrastructure-map';
    var mapSelector = '#' + mapBlockId;
    var markers = [];
    var complexMarkers = [];
    var clasters = [];
    var mapClusterComplex = [];

    $(document).on('appendGoogleMapScript', function (e, data) {
        appendGoogleMapScript(data.mapId, data.onLoadCallback, data.mapSelector);
    });

    $(document).on('initInfrastructureMap', initInfrastructureMap)

    if ($(mapSelector).length) {
        $(document).scroll(function () {
            var docOffset = $(window).scrollTop(),
                mapOffset = $(mapSelector).offset().top;

            if (docOffset + 600 >= mapOffset) {
                initInfrastructureMap();
            }
        }).scroll();
    }

    function initInfrastructureMap() {
        appendGoogleMapScript($(mapSelector).data('map-id'), function (map) {
            var center = $(mapSelector).data('center').split(',');

            if( $(mapSelector).data('zoom') ) {
                map.setZoom( $(mapSelector).data('zoom') );
            }

            map.setCenter({lat: parseFloat(center[0]), lng: parseFloat(center[1])});

            $.getJSON($('meta[name="geo-json"]').attr('content'), function (data) {
                var feature;

                for (var i = 0; i < data.features.length; i++) {
                    if (data.features[i].properties.Name === $(mapSelector).data('geo-name')) {
                        feature = data.features[i];
                        break;
                    }
                }

                if (feature !== undefined) {
                    map.data.addGeoJson(feature);
                }
            });

            map.data.setStyle(function (feature) {
                return ({
                    fillColor: 'transparent',
                    strokeColor: '#0861E8',
                    strokeWeight: 2
                });
            });

            var itemsUrl = $(mapSelector).attr('data-items-url');
            var complexId = $(mapSelector).attr('data-complex-model');
            if (complexId.length > 0) {
                itemsUrl += '?model-id='+complexId;
            }
            $.ajax({
                url: itemsUrl,
                success: function (json) {
                    var bounds = new google.maps.LatLngBounds();
                    for (var i = 0; i < json['items'].length; i++) {
                        var item = json['items'][i],
                            icon,
                            clusterIcon,
                            title = item['title'],
                            coords = item['coords'];

                        if ( item['icon'] ) {
                            icon = new google.maps.MarkerImage(
                                item['icon'], null, null, null, new google.maps.Size(45, 45)
                            );
                        } else if ( item['infrastructure_group_icon'] ) {
                            icon = new google.maps.MarkerImage(
                                item['infrastructure_group_icon'], null, null, null, new google.maps.Size(45, 45)
                            );
                        } else {
                            icon = {
                                url: '/assets/public/img/map/infrastructure-item.svg',
                                size: new google.maps.Size(19, 19),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(0, 19)
                            }
                        }

                        if ( item['infrastructure_group_cluster'] ) {
                            clusterIcon = item['infrastructure_group_cluster'];
                        } else {
                            clusterIcon = "/assets/public/img/map/clusters/cluster";
                        }

                        var myLatLng = new google.maps.LatLng(parseFloat(coords[0]), parseFloat(coords[1]));
                        var marker = new google.maps.Marker({
                            position: myLatLng,
                            map: map,
                            icon_cluster: clusterIcon,
                            icon: icon,
                            optimized: false,
                            alpha: 1
                        });
                        bounds.extend(myLatLng);

                        var popupContent = `<div class="marker-info marker-main">
                    <div>
                        <div class="marker-info__title">${title}</div>
                    </div>
                </div>`;

                        var coordinates_i = new google.maps.LatLng(parseFloat(coords[0]), parseFloat(coords[1]));

                        // Создание инфо-окна
                        var infoWindow = new INFWOverlay(
                            popupContent,
                            map,
                            coordinates_i,
                            350,
                            true
                        );

                        google.maps.event.addListener(marker, 'mouseover', (function (infoWindow) {
                            return function () {
                                infoWindow.show();
                            }
                        })(infoWindow));

                        google.maps.event.addListener(marker, 'mouseout', (function (infoWindow) {
                            return function () {
                                infoWindow.hide();
                            }
                        })(infoWindow));

                        if (typeof markers[ item['infrastructure_group_id'] ] !== "undefined") {
                            markers[ item['infrastructure_group_id'] ].push(marker);
                        } else {
                            markers[ item['infrastructure_group_id'] ] = [];
                            markers[ item['infrastructure_group_id'] ].push(marker);
                        }
                    }

                    // Кластеризация групп инфраструктуры
                    for (let markersKey in markers) {
                        var claster = new MarkerClusterer(map, markers[markersKey], {
                            imagePath: markers[markersKey][0]['icon_cluster'],
                            ignoreHidden: true,
                            zIndex: 202,
                            clusterClass: 'cluster infrastructure_cluster'
                        });
                        clasters.push(claster);
                    }

                    var complexItem = json['complex'];
                    if (complexItem != null) {
                        var complexCoords = complexItem['coords'].split(',');
                        var myLatLng = new google.maps.LatLng(parseFloat(complexCoords[0]), parseFloat(complexCoords[1]));
                        var marker = new google.maps.Marker({
                            position: myLatLng,
                            map: map,
                            title: complexItem['title'],
                            item: complexItem,
                            icon: {
                                url: '/assets/public/img/map/infrastructure-item.svg',
                                size: new google.maps.Size(19, 19),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(0, 19)
                            },
                            link: complexItem['link']
                        });
                        bounds.extend(myLatLng);

                        google.maps.event.addListener(marker, 'click', function() {
                            var infowindow = new google.maps.InfoWindow({
                                content: contentString(this['item'])
                            });
                            $('[role="dialog"]').remove();
                            infowindow.open(map,this);
                        });

                        complexMarkers.push(marker);

                        mapClusterComplex = new MarkerClusterer(map, complexMarkers, {
                            ignoreHidden: true,
                            imagePath: "/assets/public/img/map/clusters/cluster",
                            clusterClass: 'map__cluster',
                            imageSizes: [36, 36, 36, 36, 36]
                        });
                    }
                    map.fitBounds(bounds);


                    toggleMarkers(null, 'all', false);
                }
            })
        }, mapBlockId);
    }

    $('.map__toggle .toggle').click(function () {
        var $el = $(this).siblings('.map__toggle-text');
        if ( $(this).hasClass('toggle_on') ) {
            toggleMarkers(null, 'all', true);
            $('.map__legend-item').removeClass('active');
            $el.text( $el.data('hide-objects-text') );
        } else {
            $('.map__legend-item').addClass('active');
            toggleMarkers(null, 'all', false);
            $el.text( $el.data('show-places-text') );
        }
    });

    $('[data-toggle-marker]').on('click', function () {
        toggleMarkers($(this), $(this).attr('data-toggle-marker'));
    });

    function toggleMarkers(el = null, group = 'all', visible = false) {

        if (el && el.hasClass('active')) {
            visible = true;
        }

        if ( group == 'all' ) {
            markers.forEach(function (group) {
                group.forEach(function (item) {
                    item.setVisible(visible);
                });
            });
        } else  if (typeof markers[group] !== 'undefined') {
            if ( el ) {
                el.toggleClass('active');
            }
            markers[group].forEach(function (item) {
                item.setVisible(visible);
            });
        }
    }
});

$(function () {
    var mapBlockId = 'complexes-map';
    var mapSelector = '#' + mapBlockId;
    var markers = [], map, mapCluster;

    if ($(mapSelector).length) {
        initComplexesMap();
    }

    function initComplexesMap() {
        appendGoogleMapScript($(mapSelector).data('map-id'), function (loadedMap) {
            map = loadedMap;
            var center = $(mapSelector).data('center').split(',');
            map.setCenter({lat: parseFloat(center[0]), lng: parseFloat(center[1])});

            loadComplexes();
        }, mapBlockId);
    }

    $(document).on('loadComplexes', loadComplexes);
    function loadComplexes() {
        var itemsUrl = $(mapSelector).attr('data-items-url');

        $.ajax({
            url: itemsUrl,
            success: function (json) {
                reloadMarkers(json['items'])
            }
        })
    }

    $(document).on('reloadComplexesMarkers', function (e, data) {
        reloadMarkers(data.items)
    })

    function reloadMarkers(items) {
        clearOverlays(markers, mapCluster);

        for (var i = 0; i < items.length; i++) {
            var item = items[i],
                coords = item['coords'].split(',');

            var marker = new google.maps.Marker({
                position: {lat: parseFloat(coords[0]), lng: parseFloat(coords[1])},
                map: map,
                title: item['title'],
                item: item,
                icon: {
                    url: '/assets/public/img/map/infrastructure-item.svg',
                    size: new google.maps.Size(19, 19),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(0, 19)
                },
                link: item['link']
            });

            google.maps.event.addListener(marker, 'click', function() {
                var infowindow = new google.maps.InfoWindow({
                    content: contentString(this['item'])
                });
                $('[role="dialog"]').remove();
                infowindow.open(map,this);
            });

            markers.push(marker);
        }

        mapCluster = new MarkerClusterer(map, markers, {
            ignoreHidden: true,
            imagePath: "/assets/public/img/map/clusters/cluster",
            clusterClass: 'map__cluster',
            imageSizes: [36, 36, 36, 36, 36]
        });
    }
});


// begin lots map
$(function () {
    var mapBlockId = 'lots-map';
    var mapSelector = '#' + mapBlockId;
    var markers = [], map, mapCluster;

    if ($(mapSelector).length) {

        $('.filter__show-map').on('click', function(event) {
            $('.lot__map').toggleClass('show');
            $(this).toggleClass('filter__show-map_map-visible');
            $('#filter-results').toggleClass('hidden');
            $('.filter__bottom').toggleClass('hidden');
            initLotsMap();
        });
    }

    function initLotsMap() {
        appendGoogleMapScript($(mapSelector).data('map-id'), function (loadedMap) {
            map = loadedMap;
            var center = $(mapSelector).data('center').split(',');
            map.setCenter({lat: parseFloat(center[0]), lng: parseFloat(center[1])});

            loadLots();
        }, mapBlockId);
    }

    $(document).on('loadLots', loadLots);
    function loadLots() {
        var itemsUrl = $(mapSelector).attr('data-items-url');

        $.ajax({
            url: itemsUrl,
            success: function (json) {
                reloadMarkers(json['items'])
            }
        })
    }

    $(document).on('reloadLotsMarkers', function (e, data) {
        reloadMarkers(data.items)
    })

    function reloadMarkers(items) {
        clearOverlays(markers, mapCluster);

        for (var i = 0; i < items.length; i++) {
            var item = items[i],
                coords = item['coords'].split(',');

            var marker = new google.maps.Marker({
                position: {lat: parseFloat(coords[0]), lng: parseFloat(coords[1])},
                map: map,
                title: item['title'],
                item: item,
                icon: {
                    url: '/assets/public/img/map/infrastructure-item.svg',
                    size: new google.maps.Size(19, 19),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(0, 19)
                }
            });

            google.maps.event.addListener(marker, 'click', function() {
                var infowindow = new google.maps.InfoWindow({
                    content: contentString(this['item'])
                });
                $('[role="dialog"]').remove();
                infowindow.open(map,this);
            });

            markers.push(marker);
        }

        mapCluster = new MarkerClusterer(map, markers, {
            ignoreHidden: true,
            imagePath: "/assets/public/img/map/clusters/cluster",
            clusterClass: 'map__cluster',
            imageSizes: [36, 36, 36, 36, 36]
        });
    }
});
// end lots map

$(function () {
    var mapBlockId = 'contacts-map';
    var mapSelector = '#' + mapBlockId;

    if($(mapSelector).length) {
        initContactsMap();
    }

    function initContactsMap() {
        appendGoogleMapScript($(mapSelector).data('map-id'), function (map) {
            var marker = $(mapSelector).data('marker').split(',');
            map.setCenter({lat: parseFloat(marker[0]), lng: parseFloat(marker[1])});

            new google.maps.Marker({
                position: {lat: parseFloat(marker[0]), lng: parseFloat(marker[1])},
                map: map,
                title: 'Office',
                icon: {
                    url: '/assets/public/img/map/infrastructure-item.svg',
                    size: new google.maps.Size(19, 19),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(0, 19)
                }
            });
        }, mapBlockId);
    }
})

function clearOverlays(markers, mapCluster) {
    for (var i = 0; i < markers.length; i++ ) {
        markers[i].setMap(null);
    }

    if(mapCluster !== undefined) {
        mapCluster.clearMarkers();
    }

    markers.length = 0;
}
function contentString(item) {
    var cardInfo;
    var langPostfix = whitewillConfig.langPostfix;

    var title = typeof( item['title' + langPostfix] !== 'undefined')
        ? item['title' + langPostfix]
        : item['title'];

    var description = (typeof item['description' + langPostfix] !== 'undefined')
        ? item['description' + langPostfix]
        : item['description'];

    var priceContent = `<span>` + whitewillConfig.translates.from + ` `;
    var root = '/storage/';

    if(whitewillConfig.currencyCharPosition === 'before') {
        priceContent += whitewillConfig.defaultCurrencyChar;
    }

    priceContent += `<span class="min-price-${whitewillConfig.defaultCurrencyCode}">`;

    priceContent += item['min_price_' + whitewillConfig.defaultCurrencyCode];

    priceContent += '</span>';

    if(whitewillConfig.currencyCharPosition === 'after') {
        priceContent += whitewillConfig.defaultCurrencyChar;
    }

    priceContent += '</span>';

    if (item['lots_count'] != null) {
        cardInfo = `<div class="card__line">
                        <div class="card__line-item card__line-item--price-area">
                            `+priceContent+`
                            <span>|</span>
                            <span>` + whitewillConfig.translates.from + ` <span class="min-area">`+item['min_area']+`</span> ft² </span>
                        </div>
                        <div class="card__line-item card__line-item--lots-count">
                            <span><a target="_blank" class="text_blue lots-count"
                            href="/apartments/?filters=complex_id%2Fint_multiple_filter%7C`+item['id']+`%3B">`+
                                item['lots_count']+` `+ whitewillConfig.translates.properties +`
                            </a> `+ whitewillConfig.translates.properties +`</span>
                        </div>
                    </div>`;
    } else
        cardInfo = ``;

    if (whitewillConfig.isPalm)
        root += 'palm/';
    else if (whitewillConfig.isLondon)
        root += 'london/';
    return `<div class="card card_development card_development_render_googlemap show" id="render-card-`+item['id']+`">
                    <div class="card-body">
                        <div class="card-body__image">
                           <img class="card-body__image-img" src="`+root+item['images']+`" alt="`+title+`">
                        </div>
                        <a href="`+item['link']+`" class="card__title" target="_blank">`+title+`</a>
                        <div class="card__subtitle card_fw4">`+description+`</div>`+cardInfo+
                        `<a href="`+item['link']+`" class="link link_all" target="_blank">
                            <span class="link__title uppercase">` + whitewillConfig.translates.learn_more + `</span>
                        </a>
                    </div>
                </div>`;
}
